import moment, { MomentInput } from 'moment-timezone'

const utcDateFormats = [
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm:ss.SSS',
  'MM/DD/YYYY HH:mm:ss'
]

export const getUserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

export const parseUtcDate = (date: MomentInput) => {
  if (!date) {
    return moment.invalid()
  }

  const parsed = moment.utc(date, utcDateFormats, true)
  return parsed.isValid() ? parsed : moment.utc(date)
}

export const formatUtcToUserTime = (
  date: MomentInput,
  format = 'MMMM D, YYYY (h:mm a)'
) => {
  const parsed = parseUtcDate(date)

  if (!parsed.isValid()) {
    return ''
  }

  return parsed.tz(getUserTimeZone()).format(format)
}

export const getUtcDateUnix = (date: MomentInput) => {
  const parsed = parseUtcDate(date)
  return parsed.isValid() ? parsed.unix() : 0
}
